import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import $ from "jquery";

import { TimePicker, DatePicker } from 'material-ui-pickers';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Switch from '@material-ui/core/Switch';

import AutoSug from '../Common/AutoSug/AutoSug';
import {getValueWithoutVat, isNullOrEmpty, roundTime} from '../Common/helpers';
import {validateForm, blurValidations} from '../Common/formValidator';
import ModalBox from '../Common/Modals/ModalBox';

import { API } from '../../ws/constants';
import './style.css';

var moment = require('moment');

function filters(data, inputValue){
    const arr_input = inputValue.split(" ");
    const fullLabel = data.CellPhone ? data.FullName.toLowerCase() + " " + data.CellPhone : data.FullName.toLowerCase();

    for(let i=0, n=arr_input.length;i<n;i++){
        if(fullLabel.indexOf(arr_input[i]) >= 0){
            return true;
        }
    }
    return false;
}

class AddEditAppointment extends Component {
    /* START Constructor */

    constructor(props) {
        const date = moment();
        super(props);

        this.state = {
            appointmentId:this.props.props.match.params.id
            ,openModal:false
            ,returnTitle: "Erro"
            ,returnText: "Ocorreu algum erro"
            ,returnType: 1
            ,editable: false
            ,somethingWasEdited: false
            ,appointmentData:null
            ,fetchStores:null
            ,fetchServices:null
            ,servicesData:null
            ,fetchSellers:null
            ,fetchClients:null
            ,loading:false
            ,sellersWithVoucher:[]
            ,isNewClient:""
            ,addEditTitle:"Nova Marcação"
            ,maxAppDuration:typeof this.props.props.location.appMaxDur !== "undefined" ? this.props.props.location.appMaxDur : "240"
            ,blockDates: false //this.props.props.location.blockDates || this.props.props.location.blockAll ? true : false
            ,blockDuration: false //this.props.props.location.blockDuration || this.props.props.location.blockDates || this.props.props.location.blockAll ? true : false
            ,blockClientService: false //this.props.props.location.blockClientService || this.props.props.location.blockAll ? true : false
            ,storeId:typeof this.props.props.location.storeId !== "undefined" ? this.props.props.location.storeId : "1"
            ,dateAppointment:typeof this.props.props.location.appDate !== "undefined" ? moment(this.props.props.location.appDate) : date
            ,hourAppointment:typeof this.props.props.location.appHour !== "undefined" ? moment(this.props.props.location.appDate + " " + this.props.props.location.appHour) : roundTime(date, moment.duration(30, "minutes"), "round")
            ,appointmentDuration:30
            ,isClientService: typeof this.props.props.location.isClientService !== "undefined" ? this.props.props.location.isClientService : "0"
            ,clientId:typeof this.props.props.location.clientId !== "undefined" ? this.props.props.location.clientId : ""
            ,clientFirstName:""
            ,clientLastName:""
            ,clientCellPhone:""
            ,serviceId:typeof this.props.props.location.serviceId !== "undefined" ? this.props.props.location.serviceId : "0"
            ,staffId:typeof this.props.props.location.staffId !== "undefined" ? this.props.props.location.staffId : ""
            ,priceWithVat:typeof this.props.props.location.priceWithVat !== "undefined" ? this.props.props.location.isPack ? 0 : this.props.props.location.priceWithVat : ""
            ,priceWithoutVat:typeof this.props.props.location.priceWithoutVat !== "undefined" ? this.props.props.location.isPack ? 0 :this.props.props.location.priceWithoutVat : ""
            ,purchasedFrom:"1"
            ,voucherNumber:""
            ,voucherPin:""
            ,notes:""
            ,isActive:"1"
            ,clientSearch: ''
            ,staffSearch: ''
        };
    }


    /* END Constructor */

    /* START React own Functions */

    componentDidMount() {
        if(this.state.appointmentId==="New"){
            this.getMoreData(null);
        }else{
            const DEFAULT_QUERY = 'getappointments&getbyid=' + this.state.appointmentId;
            fetch(API + DEFAULT_QUERY)
            .then(response => response.json())
            .then(result => {
                if(result === null || result.shortmsg === "NOK"){
                    this.props.props.history.push('/Appointments');
                    return;
                }
                this.fillFields(result.data);
            });
        }
        blurValidations($(findDOMNode(this.refs.editForm)), { validateHiddenFields: true, showErrorMessage: true, dumbValidations: false });
    }

    /* END React own Functions */

    /* START Handles */

    getAvailableStaffByDateAndHour(date, hour, storeId, multiplier){
        return new Promise((resolve, reject) => {
            fetch(API + "getstaff&appointmentid="+this.state.appointmentId+"&getbystoreid="+storeId+"&getbydate="+moment(date).format('YYYY-MM-DD')+"&getbyhour="+moment(hour).format('HH:mm:00')+"&gethoursmultiplier="+(multiplier / 30))
            .then(response => response.json())
            .then(result => resolve(result.data));
        })
    }

    handleFieldChange = (e) => this.setState({ [e.target.id]: e.target.value, somethingWasEdited:true });
    handleSelectChange = (e) => this.setState({ [e.target.name]: e.target.value, somethingWasEdited:true });
    handleNumberChange = (e) => {
        const value = e.target.value > 0 ? e.target.value : 0;
        this.setState({ [e.target.id]: value, somethingWasEdited:true });
    }
    handleDurationChange = (e) => {
        const targetValue = e.target.value;
        const value = targetValue > 30 ? targetValue : 30;
        this.setState({ [e.target.id]: value, somethingWasEdited:true });
    }
    handlePriceWithVAT = (e) => this.setState({ priceWithoutVat: getValueWithoutVat(this.state.priceWithVat, this.props.websiteSettings.VatValue), somethingWasEdited:true });
    handleToggle = (e, value) => this.setState({ [e.target.id]: value ? "1" : "0", somethingWasEdited:true });
    handleClientServiceToggle = (e, value) => {
        this.setState({ [e.target.id]: value ? "1" : "0", somethingWasEdited:true });
        this.getClientServices(value);
    }
    handleDateAppointmentChange = (value) => {
        this.setState({dateAppointment: value, somethingWasEdited:true, loading:true});
        this.getAvailableStaffByDateAndHour(value, this.state.hourAppointment, this.state.storeId, this.state.appointmentDuration)
            .then(staffList => this.setState({fetchStaff: staffList, staffId: "", staffSearch: "", loading:false}))
            .catch(e => console.warn("An error has occurred while checking available staff (date change): " + e));
    }
    handleHourAppointmentChange = (value) => {
        value = roundTime(value, moment.duration(30, "minutes"), "round");
        this.setState({hourAppointment: value, somethingWasEdited:true, loading:true});
        this.getAvailableStaffByDateAndHour(this.state.dateAppointment, value, this.state.storeId, this.state.appointmentDuration)
            .then(staffList => this.setState({fetchStaff: staffList, staffId: "", staffSearch: "", loading:false}))
            .catch(e => console.warn("An error has occurred while checking available staff (time change): " + e));
    }
    handleStoreChange = (e) => {
        const value = e.target.value;
        this.setState({ storeId: value, somethingWasEdited:true, loading:true});
        this.getAvailableStaffByDateAndHour(this.state.dateAppointment, this.state.hourAppointment, value, this.state.appointmentDuration)
            .then(staffList => this.setState({fetchStaff: staffList, staffId: "", staffSearch: "", loading:false}))
            .catch(e => console.warn("An error has occurred while checking available staff (store change): " + e));
    }
    handlePurchasedFromChange = (e) => {
        const value = e.target.value;
        const hasV = this.state.sellersWithVoucher.indexOf(value) > -1 ? 1 : 0;
        this.setState({ purchasedFrom: value, hasVoucher:hasV, somethingWasEdited:true})
    }
    handleServiceChange = (e) => {
        const value = e.target.value;
        const prices = this.getPriceForService(value);
        this.setState({serviceId: value, priceWithVat:prices.priceWithVat, priceWithoutVat:prices.priceWithoutVat, somethingWasEdited:true});
    }

    handleSave = (e) => {
        if(!this.state.somethingWasEdited)
            return;

        this.getAvailableStaffByDateAndHour(this.state.dateAppointment, this.state.hourAppointment, this.state.storeId, this.state.appointmentDuration)
            .then(staffList => {
                if(!staffList.filter(x => x.Id === this.state.staffId).length){
                    this.setState({ returnTitle:"Erro", returnType: 2, returnText: "O Funcionário seleccionado já tem uma marcação ou não tem horário para a hora escolhida.", openModal: true});
                    return;
                }

                if(validateForm($(findDOMNode(this.refs.editForm)), { validateHiddenFields: false, showErrorMessage: true, dumbValidations: false })){
                    const wrongStaff = this.state.staffId === "" || isNaN(this.state.staffId)
                          , wrongClient = (this.state.clientId==="" || isNaN(this.state.clientId)) && isNullOrEmpty(this.state.clientFirstName) && isNullOrEmpty(this.state.clientLastName) && isNullOrEmpty(this.state.clientCellPhone);

                    if(this.state.serviceId==="" && this.state.purchasedFrom===""){
                        this.setState({ returnTitle:"Erro", returnType: 2, returnText: "Todos os campos têm que ser preenchidos!", openModal: true});
                        return;
                    }

                    if(wrongStaff || wrongClient){
                        const msg = wrongClient ? "Tem de escolher um Cliente da lista" : "Tem de escolher um Funcionário da lista";
                        this.setState({ returnTitle:"Erro", returnType: 2, returnText: msg, openModal: true});
                        return;
                    }
                    let DEFAULT_QUERY = "saveappointment&appointmentid=" + this.state.appointmentId + "&storeid=" + this.state.storeId + "&clientid=" + (this.state.isNewClient ? "" : this.state.clientId) + "&clientfirstname=" + this.state.clientFirstName
                                        + "&clientlastname=" + this.state.clientLastName + "&clientcellphone=" + this.state.clientCellPhone + "&staffid=" + this.state.staffId
                                        + "&serviceid=" + this.state.serviceId + "&pricewithvat=" + this.state.priceWithVat + "&pricewithoutvat=" + this.state.priceWithoutVat
                                        + "&dateappointment=" + moment(this.state.dateAppointment).format('YYYY-MM-DD') + "&hourappointment=" + this.state.hourAppointment.format('HH:mm:00')
                                        + "&appointmentduration=" + this.state.appointmentDuration + "&purchasedfrom=" + this.state.purchasedFrom
                                        + "&vouchernumber=" + this.state.voucherNumber + "&voucherpin=" + this.state.voucherPin + "&notes=" + this.state.notes + "&isactive=" + this.state.isActive
                                        + "&cur_userid=" + this.props.loginData.Id + "&cur_username=" + this.props.loginData.Name;

                    this.setState({loading:true});
                    fetch(API + DEFAULT_QUERY)
                    .then(response => response.json())
                    .then(result => {this.setState({ returnTitle: result.shortmsg === "OK" ? "Sucesso" : "Erro", returnType: result.shortmsg === "OK" ? 1 : 2, returnText: result.message , openModal: true, loading:false })});
                }
            })
            .catch(e => console.warn("An error has occurred while checking available staff (saving): " + e));
    }

    deleteRow = (appointmentId) => {
        if(window.confirm("Tem a certeza que quer apagar esta marcação?")){
            this.setState({loading:true});
            fetch(API + 'deleteappointment&appointmentid=' + appointmentId + "&cur_userid=" + this.props.loginData.Id + "&cur_username=" + this.props.loginData.Name)
            .then(response => response.json())
            .then(result => {
                this.setState({ returnTitle: result.shortmsg === "OK" ? "Sucesso" : "Erro", returnType: result.shortmsg === "OK" ? 1 : 2, returnText: result.message , openModal: true, loading:false });
            });
        }
    }

    /* END Handles */

    /* START Component Functions */

    getClientServices = (val) => {
        fetch(API + "getclientservices&clientid="+this.state.clientId+"&onlyactive=true")
        .then(response => response.json())
        .then(result => {
            this.setState({servicesData:val?result.data:this.state.fetchServices});
        });
    }

    getMoreData = (data) => {
        const editable = (this.props.isAdmin || this.props.loginData.profile.Appointments.permission === 1) && !this.props.props.location.blockAll
                   && ((data !== null && moment().isBefore(moment(data.DateAppointment + " " + data.HoursAppointment))) || data === null);

        const store = data !== null && typeof data.StoreId !== 'undefined' ? data.StoreId : this.state.storeId;
        const date = data !== null && typeof data.DateAppointment !== 'undefined' ? moment(data.DateAppointment) : this.state.dateAppointment;
        const hour = data !== null && typeof data.HoursAppointment !== 'undefined' ? moment(data.DateAppointment + " " + data.HoursAppointment) : this.state.hourAppointment;

        Promise.all([
            fetch(API + "getclients&onlyactive=true")
            ,fetch(API + "getsellers")
            ,fetch(API + "getservices")
            ,fetch(API + "getstores")
            ,fetch(API + "getstaff&appointmentid="+this.state.appointmentId+"&getbystoreid="+store+"&getbydate="+date.format('YYYY-MM-DD')+"&getbyhour="+hour.format('HH:mm:00'))
        ])
        .then(responses => Promise.all(responses.map(r => r.json())))
        .then((result) => {
            const staffIdProps = this.props.props.location.staffId;
            const clientIdProps = this.props.props.location.clientId;
            const setFields = data !== null ?
                      {storeId:data.StoreId !== null ? data.StoreId : "1"
                      ,clientId:data.ClientId !== null ? data.ClientId : ""
                      ,clientFullName: data.ClientFullName !== null ? data.ClientFullName + " (" + data.ClientCellPhone + ")" : ""
                      ,dateAppointment:data.DateAppointment !== null ? moment(data.DateAppointment) : null
                      ,hourAppointment:data.HoursAppointment !== null ? moment(data.DateAppointment + " " + data.HoursAppointment) : null
                      ,serviceId:data.ServiceId !== null ? data.ServiceId : ""
                      ,staffId:data.StaffId !== null ? data.StaffId : ""
                      ,staffSearch: data.StaffFullName !== null ? data.StaffFullName + " (" + data.StaffCellPhone + ")" : ""
                      ,priceWithVat:data.PriceWithVat !== null ? data.PriceWithVat : ""
                      ,priceWithoutVat:data.PriceWithoutVat !== null ? data.PriceWithoutVat : ""
                      ,purchasedFrom:data.SellerId !== null ? data.SellerId : 1
                      ,voucherNumber:data.VoucherNumber !== null ? data.VoucherNumber : ""
                      ,voucherPin:data.VoucherPin !== null ? data.VoucherPin : ""
                      ,clientGlobalNotes:data.ClientGlobalNotes !== null ? data.ClientGlobalNotes : ""
                      ,notes:data.Notes !== null ? data.Notes : ""
                      ,isActive:data.IsActive !== null ? data.IsActive : ""}
                      : null;

            if(setFields && data.DateAppointment && data.HoursAppointment){
                this.isOldAppointment = moment().isSameOrAfter(moment(data.DateAppointment + " " + data.HoursAppointment));
            }

            this.setState({
                fetchClients: result[0].data
                , appointmentData: data
                , editable
                , blockEdit: !editable || data!==null
                , blockDates: !editable || this.isOldAppointment
                , blockDuration: !editable || this.props.props.location.blockDuration /*|| this.props.props.location.blockDates*/ || this.props.props.location.blockAll || this.isOldAppointment
                , blockClientService: !editable || this.props.props.location.blockClientService || this.props.props.location.blockAll || this.state.appointmentId!=="New" || this.isOldAppointment
                , fetchSellers: result[1].data
                , sellersWithVoucher: this.setSellersWithVoucher(result[1].data)
                , fetchServices: result[2].data
                , servicesData: result[2].data
                , fetchStores: result[3].data
                , fetchStaff: result[4].data
                , staffSearch: !setFields && typeof staffIdProps !== "undefined" && result[4].data.filter(st => st.Id === staffIdProps)[0] ? result[4].data.filter(st => st.Id === staffIdProps)[0].FullName : ''
                , clientSearch: !setFields && typeof clientIdProps !== "undefined" && result[0].data.filter(c => c.Id === clientIdProps)[0] ? result[0].data.filter(c => c.Id === clientIdProps)[0].FullName : ''
                , ...setFields
            });
        });
    }

    getPriceForService = (serviceId) => {
        let services = this.state.servicesData;

        for(let i=0,n=services.length;i<n;i++){
            const service = services[i];
            var fetchSId = typeof service.ServiceId!=="undefined" ? service.ServiceId : service.Id;
            if(fetchSId === serviceId){
                const priceWithVat = !service.IsPack ? service.PriceWithVat : 0;
                const priceWithoutVat = !service.IsPack ? service.PriceWithoutVat : 0;

                return { priceWithVat, priceWithoutVat };
            }
        }
    }

    modalCallBack = (result, keepModalOpen, returnType) => {
        this.setState({ openModal: keepModalOpen });
        if(returnType === 1)
            this.props.props.history.push('/Appointments');
    }

    setSellersWithVoucher = (sellers) => {
        let swv = [];
        if(sellers===null)
            return swv;
        for (let i=0,n=sellers.length;i<n;i++) {
            if(sellers[i].HasVoucher === "1")
                swv.push(sellers[i].Id);
        }
        return swv;
    }

    fillFields(data){
        if(data!==null){
            this.getMoreData(data);
            this.getAvailableStaffByDateAndHour(this.state.dateAppointment, this.state.hourAppointment, this.state.storeId);
        }
    }

    /* END Component Functions */

    /* START Renders */

    renderStoresOptions = (e) => {
        const stores = this.state.fetchStores;
        if(stores===null)
            return;

        const items = [<MenuItem value="0" key="0" disabled={true}>Escolha uma opção</MenuItem>];
        for (let i=0,n=stores.length;i<n;i++) {
            items.push(<MenuItem value={stores[i].Id}
                                 key={stores[i].Id}>
                                    {<div><div className="smallColorDiv" style={{backgroundColor: stores[i].Color}}></div> <span>{stores[i].Name + " - " + stores[i].Shortname}</span></div>}
                       </MenuItem>);
        }
        return items;
    }

    renderServicesOptions = (e) => {
        const services = this.state.servicesData;
        if(services===null)
            return;

        let children = "";
        const items = [<MenuItem value="0" key="0" disabled={true}>Escolha uma opção</MenuItem>];
        for (let i=0,n=services.length;i<n;i++) {
            children = typeof services[i].Children!=="undefined"&&services[i].Children>0?" ("+services[i].Children+")":"";
            items.push(<MenuItem value={typeof services[i].ServiceId!=="undefined"?services[i].ServiceId:services[i].Id}
                                 key={services[i].Id}>
                                    {services[i].Shortname + " - " + services[i].Name + children}
                       </MenuItem>);
        }
        return items;
    }

    renderSellerOptions = (e) => {
        const sellers = this.state.fetchSellers;
        if(sellers===null)
            return;

        const items = [<MenuItem value="0" key="0" disabled={true}>Escolha uma opção</MenuItem>];
        for (let i=0,n=sellers.length;i<n;i++) {
            items.push(<MenuItem value={sellers[i].Id}
                                 checked={this.state.sellers && this.state.sellers.indexOf(sellers[i].Id) > -1}
                                 className="insetItem"
                                 key={sellers[i].Id}>{sellers[i].Name}</MenuItem>);
        }
        return items;
    }

    handleChangeSuggest = name => (event, { newValue }) => {
        this.setState({
            [name]: newValue,
        });
    };

    setClientValue = (sug) => {
        this.setState({clientId: sug.Id, somethingWasEdited:true});
    }

    setStaffValue = (sug) => {
        this.setState({staffId: sug.Id, somethingWasEdited:true});
    }

    render() {
        const { isAdmin, loginData } = this.props;
        const { editable } = this.state;

        const optsStores = this.renderStoresOptions()
              , optsServices = this.renderServicesOptions()
              , optsPurchasedFrom = this.renderSellerOptions()
              , loadingClass = this.state.loading ? " ajaxLoading" : "";

        let addEditTitle = this.state.addEditTitle
            ,newClientClass = !!+this.state.isNewClient ? "hidden" : ""
            ,existClientClass = !!+this.state.isNewClient ? "" : "hidden"
            ,hasVoucherClass = !!+this.state.hasVoucher ? "" : "hidden";

        if(this.state.appointmentId > 0 && this.state.appointmentData!=null){
            addEditTitle = "Marcação - " + moment(this.state.dateAppointment).format('DD/MM/YYYY') + " " + moment(this.state.hourAppointment).format('HH:mm');
        }

        return (
            <div id="addEditAppointmentPage" ref="editForm" className={"form addEditPage" + loadingClass}>
                <div className="row">
                    <div className="col-12">
                        <h1><i className="fa fa-book"></i> {addEditTitle} </h1>
                    </div>
                </div>
                <div className="row">
                    { this.state.clientGlobalNotes && loginData.profile.Clients && loginData.profile.Clients.globalNotes &&
                        <div className="col-12">
                            <div className="importantNotice importantNoticeTextfield">
                                <label>Notas Importantes</label>
                                <p><span className="dangerText">{this.state.clientGlobalNotes}</span></p>
                            </div>
                        </div>
                    }
                    <div className="fieldHolder required selectField col-md-3">
                        <FormControl fullWidth={true}>
                            <InputLabel htmlFor="storeId">Escolha a Clínica</InputLabel>
                            <Select id="storeId"
                                    name="storeId"
                                    value={this.state.storeId}
                                    onChange={this.handleStoreChange}
                                    disabled={this.state.blockDates}
                                    data-empty-error-message="Este campo não pode estar vazio">
                              {optsStores}
                            </Select>
                        </FormControl>
                    </div>
                    <div className="fieldHolder col-md-3">
                        <DatePicker
                            fullWidth={true}
                            id="dateAppointment"
                            label="Data da Marcação"
                            format="DD/MM/YYYY"
                            placeholder="Data de Envio"
                            value={this.state.dateAppointment || null}
                            locale="pt-PT"
                            onChange={this.handleDateAppointmentChange}
                            disabled={this.state.blockDates}
                        />
                    </div>
                    <div className="fieldHolder col-6 col-md-3">
                        <TimePicker
                            fullWidth={true}
                            id="hourAppointment"
                            label="Hora da Marcação"
                            value={this.state.hourAppointment}
                            onChange={this.handleHourAppointmentChange}
                            ampm={false}
                            format="HH:mm"
                            disabled={this.state.blockDates} />
                    </div>
                    <div className="fieldHolder col-6 col-md-3">
                        <TextField fullWidth={true}
                                   type="number"
                                   id="appointmentDuration"
                                   value={this.state.appointmentDuration}
                                   onChange={this.handleDurationChange}
                                   inputProps={{ max: this.state.maxAppDuration, step: "30" }}
                                   label="Dur. (minutos)"
                                   disabled={this.state.blockDuration}/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 col-md-4">
                        {this.state.fetchStaff !== null &&
                           <div className={"fieldHolder normalMarginTop staffHolder required"}>
                               <AutoSug
                                   sugValue={this.setStaffValue}
                                   sugInputValue={'suggestion.FullName'}
                                   sug={'suggestion.FullName + " ("+suggestion.CellPhone+")"'}
                                   data={this.state.fetchStaff}
                                   filter={filters}
                                   inputProps={{
                                       fullWidth: true,
                                       placeholder: 'Procurar Funcionário',
                                       label: "Procurar Funcionário",
                                       value: this.state.staffSearch,
                                       onChange: this.handleChangeSuggest('staffSearch'),
                                       disabled: !editable || this.state.fetchStaff.length === 0
                                   }}
                               />
                           </div>}
                    </div>
                    <div className="col-12 col-md-5">
                        {this.state.fetchClients!=null &&
                            <div className={"fieldHolder normalMarginTop clientsHolder required " + newClientClass}>
                                <AutoSug
                                    sugValue={this.setClientValue}
                                    sugInputValue={'suggestion.FullName'}
                                    sug={'suggestion.FullName + " ("+suggestion.CellPhone+")"'}
                                    data={this.state.fetchClients}
                                    filter={filters}
                                    inputProps={{
                                        fullWidth: true,
                                        placeholder: 'Procurar Cliente',
                                        label: "Procurar Cliente",
                                        value: this.state.clientFullName || this.state.clientSearch,
                                        onChange: this.handleChangeSuggest('clientSearch'),
                                        disabled: this.state.blockClientService,
                                    }}
                                />
                           </div>
                        }
                    </div>
                    <div className="col-12 col-md-3">
                        <div className="fieldHolder buttonsHolder">
                            <FormControlLabel
                                control={
                                    <Switch
                                        id="isNewClient"
                                        checked={!!+this.state.isNewClient}
                                        disabled={this.state.blockClientService}
                                        onChange={this.handleToggle}
                                        color="primary"/>
                                }
                                label="Novo cliente?"/>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className={"newClientHolder col-12 " + existClientClass}>
                        <div className="row">
                            <div className="fieldHolder required col-md-4">
                                <TextField fullWidth={true}
                                           id="clientFirstName"
                                           value={this.state.clientFirstName}
                                           onChange={this.handleFieldChange}
                                           label="Primeiro Nome do Cliente"
                                           placeholder="Introduza o primeiro nome"
                                           disabled={this.state.blockEdit}
                                           data-empty-error-message="Este campo não pode estar vazio" />
                            </div>
                            <div className="fieldHolder required col-md-4">
                                <TextField fullWidth={true}
                                           id="clientLastName"
                                           value={this.state.clientLastName}
                                           onChange={this.handleFieldChange}
                                           label="Último Nome do Cliente"
                                           placeholder="Introduza o último nome"
                                           disabled={this.state.blockEdit}
                                           data-empty-error-message="Este campo não pode estar vazio" />
                            </div>
                            <div className="fieldHolder required col-md-4">
                                <TextField fullWidth={true}
                                           id="clientCellPhone"
                                           value={this.state.clientCellPhone}
                                           onChange={this.handleFieldChange}
                                           label="Contacto do Cliente"
                                           placeholder="Introduza o telefone"
                                           disabled={this.state.blockEdit}
                                           data-empty-error-message="Este campo não pode estar vazio" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 col-md-2">
                        <div className="fieldHolder smallerToggle">
                            <FormControlLabel
                                control={
                                    <Switch
                                        id="isClientService"
                                        checked={!!+this.state.isClientService}
                                        disabled={!editable || this.state.clientId==="" || this.state.blockClientService}
                                        onChange={this.handleClientServiceToggle}
                                        color="primary"/>
                                }
                                label="Serviços do cliente"/>
                        </div>
                    </div>
                    <div className="fieldHolder required selectField col-12 col-md-4">
                        <FormControl fullWidth={true}>
                            <InputLabel htmlFor="serviceId">{this.state.isClientService==="1" ? "Serviço do Cliente" : "Novo Serviço"}</InputLabel>
                            <Select id="serviceId"
                                    name="serviceId"
                                    value={this.state.serviceId}
                                    onChange={this.handleServiceChange}
                                    disabled={this.state.blockClientService}
                                    data-empty-error-message="Este campo não pode estar vazio">
                              {optsServices}
                            </Select>
                        </FormControl>
                    </div>
                    <div className="col-12 col-md-3">
                        <div className="fieldHolder required moneyHolder">
                            <TextField fullWidth={true}
                                       id="priceWithVat"
                                       value={this.state.priceWithVat}
                                       onChange={this.handleNumberChange}
                                       onBlur={this.handlePriceWithVAT}
                                       ref="priceWithVat"
                                       label="Preço com IVA"
                                       placeholder="Preço com IVA"
                                       data-empty-error-message="Este campo não pode estar vazio"
                                       disabled={this.state.blockClientService || !!+this.state.isClientService}/>
                        </div>
                    </div>
                    <div className="col-12 col-md-3">
                        <div className="fieldHolder required moneyHolder">
                            <TextField fullWidth={true}
                                       id="priceWithoutVat"
                                       value={this.state.priceWithoutVat}
                                       onChange={this.handleNumberChange}
                                       ref="priceWithoutVat"
                                       label="Preço sem IVA"
                                       placeholder="Preço sem IVA"
                                       data-empty-error-message="Este campo não pode estar vazio"
                                       disabled />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 col-md-6">
                        <div className="fieldHolder required selectField">
                            <FormControl fullWidth={true}>
                                <InputLabel htmlFor="purchasedFrom">Onde adquiriu o serviço</InputLabel>
                                <Select id="purchasedFrom"
                                        name="purchasedFrom"
                                        value={this.state.purchasedFrom}
                                        onChange={this.handlePurchasedFromChange}
                                        disabled={this.state.blockEdit}
                                        data-empty-error-message="Este campo não pode estar vazio">
                                  {optsPurchasedFrom}
                                </Select>
                            </FormControl>
                        </div>
                        <div className={"voucherHolder " + hasVoucherClass}>
                            <div className="fieldHolder required">
                                <TextField fullWidth={true}
                                           id="voucherNumber"
                                           value={this.state.voucherNumber}
                                           onChange={this.handleFieldChange}
                                           label="Número do voucher"
                                           placeholder="Introduza o Número do voucher"
                                           disabled={this.state.blockEdit}
                                           data-empty-error-message="Este campo não pode estar vazio" />
                            </div>
                            <div className="fieldHolder">
                                <TextField fullWidth={true}
                                           id="voucherPin"
                                           value={this.state.voucherPin}
                                           onChange={this.handleFieldChange}
                                           label="PIN do voucher"
                                           placeholder="Introduza o PIN do voucher"
                                           disabled={this.state.blockEdit} />
                            </div>
                        </div>
                    </div>
                    <div className="fieldHolder col-md-6">
                        <TextField fullWidth={true}
                                   id="notes"
                                   value={this.state.notes}
                                   onChange={this.handleFieldChange}
                                   disabled={!editable}
                                   multiline={true}
                                   rows={4}
                                   label="Observações" />
                    </div>
                </div>
                <div className="row">                        
                    <div className="col-12 buttonsHolder">
                        <Button onClick={this.props.props.history.goBack} variant="contained" className="defaultButton">Voltar</Button>
                        { (isAdmin || loginData.profile.Appointments.DEL) && this.state.appointmentId !== "New" && !this.isOldAppointment && <Button onClick={this.handleDelete} className="button button-danger" variant="contained" title="Cancelar Marcação">Cancelar Marcação</Button>}
                        { editable && <Button onClick={this.handleSave} className="button float-right" variant="contained" color="primary"><i className='fa fa-check'></i> Salvar</Button>}
                    </div>
                </div>
                {this.state.openModal && <ModalBox modalCallBack={this.modalCallBack} isActive={this.state.openModal} returnType={this.state.returnType} modalHtml={<div className="col-12"><h2>{this.state.returnTitle}</h2><p>{this.state.returnText}</p></div>} />}
            </div>
        );
    }
}

export default AddEditAppointment;
